import React from 'react'
import PropTypes from 'prop-types'
// import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import './cpur3.css'
// import { Area } from '@ant-design/charts'

function Cpur3({
  alerts,
  ecbCount,
  completedCalls,
  missedCalls,
  callsInQueue,
}) {
  // var config = {
  //   data: data,
  //   xField: 'ecb',
  //   yField: 'alerts',
  //   height: 'auto',
  //   width: 'auto',
  // }

  return (
    <div className="cpur cpur3">
      <div className="sify-cpu-titles">ECB Management</div>
      <div className="cpur3-ecb">
        <div className="cpur3-ecb-sub">
          <div className="cpur3-sub1">
            <span className="dashboard-title-color">Alerts :</span>{' '}
            <span className="cpur3-sub-value">{alerts}</span>
          </div>
          <div></div>
          <div className="cpur3-sub2">
            <span className="dashboard-title-color">No ECBs :</span>{' '}
            <span className="cpur3-sub-value">{ecbCount}</span>
          </div>
        </div>
        <div className="cpur3-ecb-sub">
          <div className="cpur3-sub1">
            <span className="dashboard-title-color">Call Volume :</span>{' '}
            <span className="cpur3-sub-value">
              {completedCalls + missedCalls + callsInQueue}
            </span>
          </div>
          <div></div>
          <div className="cpur3-sub2">
            <span className="dashboard-title-color">Completed Calls :</span>{' '}
            <span className="cpur3-sub-value">{completedCalls}</span>
          </div>
        </div>
        <div className="cpur3-ecb-sub">
          <div className="cpur3-sub1">
            <span className="dashboard-title-color">Missed Calls :</span>{' '}
            <span className="cpur3-sub-value">{missedCalls}</span>
          </div>
          <div></div>
          <div className="cpur3-sub2">
            <span className="dashboard-title-color">Calls in queue :</span>{' '}
            <span className="cpur3-sub-value">{callsInQueue}</span>
          </div>
        </div>
        {/* <div className="cpur3-chart">
          <Area {...config} />
        </div> */}
      </div>
    </div>
  )
}

Cpur3.propTypes = {
  data: PropTypes.array,
  usage: PropTypes.number,
  space: PropTypes.number,
  cpu: PropTypes.number,
}

export default Cpur3
